import { createAction, props } from '@ngrx/store';
import { WorkerCertificate, CertificationAlert, CertificationMonitorSummary } from '../safety-certification.models';

export const CertificationActions = {
  // Load certifications
  loadProjectCertifications: createAction(
    '[Safety Certifications] Load Project Certifications',
    props<{ projectId: number }>()
  ),

  loadProjectCertificationsSuccess: createAction(
    '[Safety Certifications] Load Project Certifications Success',
    props<{ certificates: WorkerCertificate[] }>()
  ),

  loadProjectCertificationsError: createAction(
    '[Safety Certifications] Load Project Certifications Error',
    props<{ error: string }>()
  ),

  // Load expiring Soon
  loadExpiringSoon: createAction(
    '[Safety Certifications] Load Expiring Soon',
    props<{ projectId: number; daysOut: number }>()
  ),

  loadExpiringSoonSuccess: createAction(
    '[Safety Certifications] Load Expiring Soon Success',
    props<{ certificates: WorkerCertificate[]; daysOut: number }>()
  ),

  loadExpiringSoonError: createAction(
    '[Safety Certifications] Load Expiring Soon Error',
    props<{ error: string }>()
  ),

  // Load expired
  loadExpired: createAction(
    '[Safety Certifications] Load Expired',
    props<{ projectId: number }>()
  ),

  loadExpiredSuccess: createAction(
    '[Safety Certifications] Load Expired Success',
    props<{ certificates: WorkerCertificate[] }>()
  ),

  loadExpiredError: createAction(
    '[Safety Certifications] Load Expired Error',
    props<{ error: string }>()
  ),

  // Load summary
  loadCertificationSummary: createAction(
    '[Safety Certifications] Load Summary',
    props<{ projectId: number }>()
  ),

  loadCertificationSummarySuccess: createAction(
    '[Safety Certifications] Load Summary Success',
    props<{ summary: CertificationMonitorSummary }>()
  ),

  loadCertificationSummaryError: createAction(
    '[Safety Certifications] Load Summary Error',
    props<{ error: string }>()
  ),

  // Load alerts
  loadCertificationAlerts: createAction(
    '[Safety Certifications] Load Alerts',
    props<{ projectId: number }>()
  ),

  loadCertificationAlertsSuccess: createAction(
    '[Safety Certifications] Load Alerts Success',
    props<{ alerts: CertificationAlert[] }>()
  ),

  loadCertificationAlertsError: createAction(
    '[Safety Certifications] Load Alerts Error',
    props<{ error: string }>()
  ),

  // Clear state
  clearCertifications: createAction(
    '[Safety Certifications] Clear'
  )
};
